export const MCP_CONNECTION_LINK_HEADERS = {
    "cache-control": "private, no-store, max-age=0",
    "referrer-policy": "same-origin",
    "x-robots-tag": "noindex, nofollow",
    "content-security-policy":
        "default-src 'none'; style-src 'unsafe-inline'; form-action 'self'; frame-ancestors 'none'; base-uri 'none'",
    "x-content-type-options": "nosniff",
};
